export default __webpack_public_path__ + "static/media/365.fc05ce0b.gif";